import { ArrowSquareOut } from '@phosphor-icons/react';
import { SVG_SIZE_M, SVG_SIZE_S } from 'src/constants';
import { LEARN_MORE_PRICES_LINK } from 'src/constants/externalLinks';
import { NinjaAgentsOutlinedIcon } from 'src/images/icons/ninjaAgentsOutlined';
import styles from './PaymentPageFooter.module.scss';
import { sendGTMEvent } from 'src/utils/analytics';
import { GTMEvent } from 'src/types';

export const PaymentPageFooter = () => {
  const handleCompareAllPlanFeaturesClick = () => {
    sendGTMEvent(GTMEvent.PAYMENT_COMPARE_PLAN_FEATURES_CLICK);
  };

  return (
    <div className={styles.footerWrapper}>
      <div className={styles.footer}>
        <div className={styles.hints}>
          <div className={styles.hintRow}>
            <span className={styles.icon}>*</span>
            <span>
              Subject to abuse thresholds. High volume usage may slow down the
              processing of your request
            </span>
          </div>

          <div className={styles.hintRow}>
            <NinjaAgentsOutlinedIcon width={SVG_SIZE_S} height={SVG_SIZE_S} />
            <span>
              Ninja LLM: Fine-tuned and powered by Ninja’s infrastructure
            </span>
          </div>
        </div>

        <a
          href={LEARN_MORE_PRICES_LINK}
          target="_blank"
          rel="noreferrer"
          className={styles.comparePlanLink}
          onClick={handleCompareAllPlanFeaturesClick}
        >
          <ArrowSquareOut size={SVG_SIZE_M} />
          <span>Compare all plan features</span>
        </a>
      </div>
    </div>
  );
};
